import InvoiceFilters from "./InvoiceFilters";
import InvoiceTable from "./InvoiceTable";
import InvoicePagination from "./InvoicePagination";
import ReprintModal from "./modals/ReprintModal";
import { useInvoices } from "../../hooks/useInvoices";
import { useReprint } from "../../hooks/useReprint";
import { validateDateRange } from "../../components/utils/invoiceValidation";

import Swal from "sweetalert2";
import "./Invoicelist.css";

export default function InvoiceList() {
  const {
    invoices,
    loading,
    fromDate,
    toDate,
    currentPage,
    totalPages,
    total,
    from,
    to,
    setFromDate,
    setToDate,
    fetchInvoices,
    handlePageChange,
    handleClearFilters,
  } = useInvoices();

  const {
    showReprintModal,
    saleToReprint,
    handleOpenReprint,
    handleCloseReprint,
  } = useReprint();

  const handleSearch = () => {
    const validation = validateDateRange(fromDate, toDate);
    if (!validation.valid) {
      return Swal.fire("Notice", validation.message, "warning");
    }
    fetchInvoices(1);
  };

  return (
    <div className="invoice-list-container">
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">📄 Invoices</h2>
        </div>

        <div className="card-body">
          <InvoiceFilters
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            onSearch={handleSearch}
            onClear={handleClearFilters}
          />

          <div className="results-info">
            <p>
              Showing <strong>{from} - {to}</strong> of <strong>{total}</strong> invoices
            </p>
          </div>

          <InvoiceTable
            invoices={invoices}
            loading={loading}
            onClearFilters={handleClearFilters}
            hasFilters={!!(fromDate || toDate)}
            onReprint={handleOpenReprint}
          />

          {!loading && (
            <InvoicePagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>

      <ReprintModal
        show={showReprintModal}
        sale={saleToReprint}
        onClose={handleCloseReprint}
      />
    </div>
  );
}